export default __webpack_public_path__ + "static/media/Sophos.b8b1421b.svg";